module.exports = __webpack_public_path__ + "media/promo/velle/images/products/prod_7-9bea0bef24d356249adf79ab32573f8a.png";